import { useEffect, useState } from "react";
import { breakpoints } from "@app/design-system/tokens";

const DESKTOP_QUERY = `(min-width: ${breakpoints.xl}), (min-width: ${breakpoints.xlLandscape}) and (orientation: landscape)`;

/**
 * True once the viewport is wide enough for the persistent map + fixed-width
 * panel desktop shell (see `DesktopTrackingShell`) — either a real desktop
 * window (`breakpoints.xl`, any orientation) or a tablet in landscape
 * (`breakpoints.xlLandscape`, the lower threshold, gated to landscape only
 * so portrait tablets and landscape phones don't cross it — see
 * `breakpoints.ts`). Portrait viewports below `xl` keep the existing
 * single-column mobile layout untouched.
 */
export function useIsDesktopViewport(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
}
